import { IForm } from '@/components/types'
import { useSearchDateShortcut } from '@/hooks/useSearch'
const shortcuts = useSearchDateShortcut()

export const searchFormConfig: IForm = {
  formItems: [
    {
      field: 'channel',
      type: 'select',
      label: '来源渠道',
      clearable: true,
      placeholder: '请选择来源渠道',
      options: [
        { title: '未知', value: 0 },
        { title: '推广素材', value: 1 },
        { title: '复播', value: 2 },
        { title: '直播', value: 3 }
      ]
    },
    {
      field: 'deptId',
      type: 'select',
      label: '部门',
      clearable: true,
      placeholder: '请选择部门'
    },
    {
      field: 'createdTime',
      type: 'datepicker',
      label: '创建时间',
      otherOptions: {
        startPlaceholder: '开始时间',
        endPlaceholder: '结束时间',
        type: 'daterange',
        'value-format': 'YYYY-MM-DD',
        disabledDate: (date: Date) => {
          return new Date() < date
        },
        shortcuts: shortcuts
      }
    }
  ]
}
